<div>
    <app-tool-bar [title]="'Manage Users'" [iconName]="'pi-user'" 
    (handleAdd)="isAddUser = true"
    [isAdd]="true"></app-tool-bar>
</div>
<div class="p-4 overflow-auto h-[85vh]">
    <p-progressbar mode="indeterminate" [style]="{ height: '3px' }"
    *ngIf="!initialLoad && loading"></p-progressbar>
    <p-table [value]="dataSource" [paginator]="true"
    (onLazyLoad)="loadData($event)"
    [rows]="rows" [totalRecords]="totalRecords" [lazy]="true"
    [rowsPerPageOptions]="totalRecords > 10 ? [10, 20, 50] : undefined"
         [loading]="initialLoad"
        
        >
        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.sortable ? col.field : ''">
                    {{ col.header }}
                    <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td *ngFor="let col of columns">
                    <ng-container [ngSwitch]="col.type">
                        <!-- Handle Nested Object (Lead Owner) -->
                        <ng-container *ngSwitchCase="'nested'">
                            {{ (rowData.user?.prefix ?? 'N/A') +
                            (rowData.user?.fname ? ' ' + rowData.user.fname : '') +
                            (rowData.user?.lname ? ' ' + rowData.user.lname : '') }}
                        </ng-container>
    
                        <!-- Handle Boolean -->
                        <ng-container *ngSwitchCase="'role'">
                            {{
                                rowData?.role?.name
                            }}
                        </ng-container>

                        <!-- date -->
                        <ng-container *ngSwitchCase="'date'">
                            {{
                                rowData[col.field] | date: 'dd/MM/yyyy'
                            }}
                        </ng-container>
    
                        <!-- Handle Actions -->
                        <ng-container *ngSwitchCase="'actions'">
                            <p-menu [tabindex]="undefined" #menu [model]="getMenuItems(menu, rowData)" [popup]="true" appendTo="body"></p-menu>
                            <i (click)="menu.toggle($event)" class="pi pi-ellipsis-h action-button"></i>
                          </ng-container>
                          
    
                        <!-- Default Case (Normal Field) -->
                        <ng-container *ngSwitchDefault>
                            {{ rowData[col.field] }}
                        </ng-container>
                    </ng-container>
                </td>
            </tr>
        </ng-template>
    
        <ng-template pTemplate="loading">
            <tr>
                <td colspan="3" class="text-center">
                    <p-progressSpinner></p-progressSpinner>
                </td>
            </tr>
        </ng-template>

        <!-- when data length is 0 -->

        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="columns.length" class="no-data">
                    <p>No records found</p>
                </td>
            </tr>
        </ng-template>

    </p-table>
</div>


<p-dialog [modal]="true" [(visible)]="isAddUser"  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" closable="false"
[style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <app-add-user 
    [formAction]="'Add'"
    (reload)="loadData({first: 0, rows: rows})"

    (closeDialog)="isAddUser = false"></app-add-user>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="isEditUser"  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" closable="false"
[style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <app-add-user 
    [formAction]="'Edit'"
    (reload)="loadData({first: 0, rows: rows})"
    [userDataToEdit]="userDataToEdit"
    (closeDialog)="isEditUser = false"></app-add-user>
</p-dialog>

<!-- reser password -->

<p-dialog [modal]="true" [(visible)]="isResetPassword"  [breakpoints]="{ '1199px': '40vw', '575px': '90vw' }" closable="false"
[style]="{ width: '30vw' }" [draggable]="false" [resizable]="false">
    <app-reset-password 
    [userDataToEdit]="userDataToEdit"
    (closeDialog)="isResetPassword = false"></app-reset-password>
</p-dialog>


<p-dialog [modal]="true" [(visible)]="isDeleteUser"  [breakpoints]="{ '1199px': '40vw', '575px': '90vw' }" closable="false"
[style]="{ width: '30vw' }" [draggable]="false" [resizable]="false">
    <app-delete-user 
    [userDataToEdit]="userDataToEdit"
    (reload)="loadData({first: 0, rows: rows})"
    (closeDialog)="isDeleteUser = false"></app-delete-user>
</p-dialog>


